import {Component, createElement as h} from "react";

import {Link} from "./cst2";

type RerenderLink = Link<JSX.Element, {
    forceUpdate : (cb?:() => void) => void,
    invoke      : (cb?:() => void) => void,
}>;

export const Rerender = ({next}:{next: RerenderLink}) => h(Rerender1, {next});

class Rerender1 extends Component<{next: RerenderLink}> {
    unmounted = false;
    componentWillUnmount() {
        this.unmounted = true;
    }

    render() {
        const {next} = this.props;

        return next({
            invoke: (cb=undefined) => {
                !this.unmounted && setTimeout(
                    () => !this.unmounted && this.forceUpdate(cb),
                    0,
                )
            },
            forceUpdate: (cb) => this.forceUpdate(cb),
        });
    }
}
